export default {"src":"/_next/static/media/laboratory-occupational-medicine.0be3edc0.svg","height":164,"width":172,"blurWidth":0,"blurHeight":0};